module.exports = __webpack_public_path__ + "static/media/Sabrina_A@3x.f62b138f.jpg";